import Vue from 'vue'

export const globalPass = Vue.observable({
  active: false,
  pass:''
})

export const globalPassActions = {
  show () {
    globalPass.active = true
    globalPass.pass = ''
  },
  close () {
    globalPass.active = false
    globalPass.pass = ''
  },
  send () {
    globalPass.active = false
  },
  set (val) {
    globalPass.pass = val
  },
  get () {
    return globalPass.pass
  },
  clear () {
    globalPass.pass = ''
  }
}